import React, { Component } from "react";
import { Modal } from "reactstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

import { Button } from "../../Button";
import styles from "./styles.scss";

export interface MobileSubModalProps {
  visible: boolean;
  toggleModal(): void;
}

class MobileSubModal extends Component<MobileSubModalProps, {}> {
  render() {
    const { visible, toggleModal } = this.props;
    return (
      <Modal
        className="rotoql-mobile-sub-modal__dialog"
        contentClassName="rotoql-mobile-sub-modal__content"
        modalClassName="rotoql-mobile-sub-modal"
        wrapClassName="rotoql-mobile-sub-modal__wrapper"
        backdropClassName="rotoql-mobile-sub-modal__backdrop"
        isOpen={visible}
        toggle={toggleModal}
        slide="false"
        size="lg"
        centered
      >
        <div className="rotoql-mobile-sub-modal__close" onClick={toggleModal}>
          <Icon path={mdiClose} size="20px" color="#262626" />
        </div>
        <div className="rotoql-mobile-sub-modal__body-text">
          We have detected you have subscribed to the mobile app. In order to change your subscription, manage through
          your device's app store.
        </div>
        <div className="rotoql-mobile-sub-modal__button-container">
          <Button className="rotoql-mobile-sub-modal__button" onClick={() => toggleModal()}>
            CLOSE
          </Button>
        </div>
        <style jsx>{styles}</style>
      </Modal>
    );
  }
}

export default MobileSubModal;
